<template>
    <div class="filter-breadcrumb filter-breadcrumb_budget-programs">
        <span class="item-breadcrumb" v-if="curRegion" @click="openFilterByRef('curRegionRef')">
            {{ getBPText('breadcrumbs.region', { code: curRegion.code }) }}
        </span>
        <span class="item-breadcrumb" v-if="curYear" @click="openFilterByRef('curYearRef')">
            {{ curYear.name}}
        </span>
        <span class="item-breadcrumb" v-if="curAbp" @click="openFilterByRef('abpRef')">
            {{ getBPText('breadcrumbs.abp', { abp: curAbp.abp }) }}
        </span>
        <span class="item-breadcrumb" v-if="curDataType && main"  @click="openFilterByRef('curDataTypeRef')">
            {{ locName(curDataType) }}
        </span>
        <span class="item-breadcrumb" v-if="curBudgetVersion"  @click="openFilterByRef('curVerRef')">
            {{ versionName }}
        </span>
        <span class="item-breadcrumb" v-if="curPrgId && !main">
            {{ getBPText('breadcrumbs.bp', { prg: curPrgId }) }}
        </span>
        
    </div>
</template>
<script>
export default {
    name: 'CBreadCrumbs',
    props: {
        curRegion: Object,
        curYear: Object,
        curAbp: Object,
        curBudgetVersion: Object,
        curDataType: Object,
        curPrgId: {
            default: null,
            type: Number
        },
        main: {
            default: false,
            type: Boolean
        }
    },
    computed: {
        versionName() {
            const name = this.locName(this.curBudgetVersion);
            if (this.curBudgetVersion.isVersionActive) return `${name} ${this.getBPText('filter.status_active')}`;
            if (this.curBudgetVersion.isVersionAppruved) return `${name} ${this.getBPText('filter.status_approved')}`;
            return name;
        }
    },
    methods: {
        openFilterByRef(refName) {
            this.$emit('openFilterByRef', refName);
        },
        locName(obj, kkField = 'name_kk') {
            return (this.$i18n.locale === 'kk' && obj[kkField]) || obj.name_ru;
        },
        getBPText(field, params) {
            return this.$t(`modules.budget_request.budget_programs.${field}`, params);
        }
    }
};

</script>
<style scoped>
    .filter-breadcrumb_budget-programs {
        height: fit-content;
        display: block !important;
    }
</style>
